const translation = {
  title: 'Razišči',
  sidebar: {
    discovery: 'Odkritja',
    chat: 'Klepet',
    workspace: 'Delovni prostor',
    action: {
      pin: 'Pripni',
      unpin: 'Odpni',
      rename: 'Preimenuj',
      delete: 'Izbriši',
    },
    delete: {
      title: 'Izbriši aplikacijo',
      content: 'Ali ste prepričani, da želite izbrisati to aplikacijo?',
    },
  },
  apps: {
    title: 'Razišči aplikacije Dify',
    description: 'Uporabite te predloge aplikacij takoj ali prilagodite svoje aplikacije na podlagi predlog.',
    allCategories: 'Priporočeno',
  },
  appCard: {
    addToWorkspace: 'Dodaj v delovni prostor',
    customize: 'Prilagodi',
  },
  appCustomize: {
    title: 'Ustvari aplikacijo iz {{name}}',
    subTitle: 'Ikona aplikacije & ime',
    nameRequired: 'Ime aplikacije je obvezno',
  },
  category: {
    Assistant: 'Pomočnik',
    Writing: 'Pisanje',
    Translate: 'Prevajanje',
    Programming: 'Programiranje',
    HR: 'Kadri',
    Workflow: 'Potek dela',
    Agent: 'Agent',
    Entertainment: 'Zabava',
  },
}

export default translation
